import { applicantResponseSESchema } from '@/api/SE/applicants/schemas';
import type {
  ApplicantAddonProductsPayload,
  ApplicantEmploymentStatusPayload,
  ApplicantFinancesPayload,
  ApplicantLivingPayload,
  ApplicantLoanPurposePayload,
  ApplicantPersonalDetailsPayloadSE,
} from '@/api/SE/applicants/types';
import { apiRequest } from '@/api/utils/api';

export * from '@/api/SE/applicants/types';

export const createApplicant = (payload: ApplicantPersonalDetailsPayloadSE) =>
  apiRequest({
    url: '/se/applicants',
    method: 'POST',
    schema: applicantResponseSESchema,
    data: payload,
  });

export const updateApplicant = (applicantId: string, payload: ApplicantPersonalDetailsPayloadSE) =>
  apiRequest({
    url: `/se/applicants/${applicantId}`,
    method: 'PUT',
    schema: applicantResponseSESchema,
    data: payload,
  });

export const getApplicant = (applicantId: string) =>
  apiRequest({ url: `/se/applicants/${applicantId}`, method: 'GET', schema: applicantResponseSESchema });

export const updateApplicantEmploymentStatus = (
  applicantId: string,
  payload: ApplicantEmploymentStatusPayload,
) =>
  apiRequest({
    url: `/se/applicants/${applicantId}/employment-status`,
    method: 'PUT',
    schema: applicantResponseSESchema,
    data: payload,
  });

export const updateApplicantLoanPurpose = (applicantId: string, payload: ApplicantLoanPurposePayload) =>
  apiRequest({
    url: `/se/applicants/${applicantId}/loan-purpose`,
    method: 'PUT',
    schema: applicantResponseSESchema,
    data: payload,
  });

export const updateApplicantLiving = (applicantId: string, payload: ApplicantLivingPayload) =>
  apiRequest({
    url: `/se/applicants/${applicantId}/living`,
    method: 'PUT',
    schema: applicantResponseSESchema,
    data: payload,
  });

export const updateApplicantAddonProducts = (applicantId: string, payload: ApplicantAddonProductsPayload) =>
  apiRequest({
    url: `/se/applicants/${applicantId}/addon-products`,
    method: 'PUT',
    schema: applicantResponseSESchema,
    data: payload,
  });

export const updateApplicantFinances = (applicantId: string, payload: ApplicantFinancesPayload) =>
  apiRequest({
    url: `/se/applicants/${applicantId}/finances`,
    method: 'PUT',
    schema: applicantResponseSESchema,
    data: payload,
  });
